import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import List from './list'
import Layout from '../layout.vue'

const basePath = '/v-admin/applicant-lock/config'

export default {
  path: basePath,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_HR_APPLICANT_LOCK', 'PREMIUM_APPLICANT_LOCK'],
    titleI18nKey: 'admin.company.applicantLock.title',
    menu: {
      get label () {
        return i18n.t('admin.company.applicantLock.title')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: basePath,
      component: List,
      meta: {
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.applicantLock.title'
      }
    }
  ]
}
